import { gql } from "@apollo/client";

export const GROUP_EXTERNAL_TRANSFER = gql`
  mutation SpendGroupExternalTransfer(
    $input: SpendGroupExternalTransferInput!
  ) {
    spendGroupExternalTransfer(input: $input) {
      amount
      descriptor
      id
      status
    }
  }
`;

export const DELETE_GROUP_COUNTERPARTY = gql`
  mutation SpendGroupCounterpartyDelete(
    $counterpartyId: String!
    $groupId: String!
  ) {
    spendGroupCounterpartyDelete(
      counterpartyId: $counterpartyId
      groupId: $groupId
    ) {
      success
    }
  }
`;

export const GROUP_ACH_CREDIT = gql`
  mutation SpendGroupACHCredit($input: SpendGroupACHCredit) {
    spendGroupACHCredit(input: $input) {
      paymentId
      approvalId
    }
  }
`;

export const CREATE_GROUP_COUNTERPARTY = `
  mutation SpendGroupCounterpartyCreate($vgsInput: SpendCounterpartyCreateInput) {
    spendGroupCounterpartyCreate(input: $vgsInput) {
      id
    }
  }
`;

export const SEND_GROUP_CHECK = gql`
  mutation SpendGroupCheckSend($input: SpendCheckInput!) {
    spendGroupCheckSend(input: $input) {
      id
      type
      approvalId
      status
    }
  }
`;

export const UPDATE_GROUP_PAYEE = gql`
  mutation SpendGroupPayeeUpdate($input: SpendPayeeUpdateInput!) {
    spendGroupPayeeUpdate(input: $input) {
      payeeId
    }
  }
`;

export const CREATE_GROUP_PAYEE = `
  mutation SpendGroupPayeeCreate($vgsInput: SpendPayeeInput!) {
    spendGroupPayeeCreate(input: $vgsInput) {
      payeeId
    }
  }
`;

export const CREATE_GROUP_DEBIT_CARD_STRING = `
  mutation SpendGroupDebitCardCreate(
    $vgsInput: SpendDebitCardInput!
    $id: String
  ) {
    spendGroupDebitCardCreate(input: $vgsInput, id: $id) {
      id
      approvalId
    }
  }`;
